import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import useComponentBounds from '../../../../../../hooks/useComponentBounds';
import {
  getCardElementFrameContainerStyle,
  getCardElementFrameStyle,
} from '../CardDesignerCardElementFrame/helpers';
import CardDesignerCardElementPlaceholder from '../CardDesignerCardElementPlaceholder';
import Badge from '../../../../Badge';
import { DESIGN_MODES } from '../../../constants';

const propTypes = {
  className: PropTypes.string,
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }).isRequired,
  designMode: PropTypes.oneOf(Object.values(DESIGN_MODES)),
};

const CardDesignerCardElementBackground = ({
  className,
  element,
  designMode,
}) => {
  const ref = useRef();
  const { bounds } = useComponentBounds(ref);
  const classes = classNames({
    [className]: !!className,
    'card-designer-card-element-background': true,
  });
  const { cardElementConfiguration } = element;
  const { help_placeholder: helpPlaceholder } = cardElementConfiguration ?? {};
  const isIdCards = designMode === DESIGN_MODES.ID_CARDS;

  return (
    <div
      ref={ref}
      className={classes}
      style={{
        position: 'absolute',
        ...getCardElementFrameStyle(element),
      }}
    >
      <div style={{ ...getCardElementFrameContainerStyle(element, bounds) }}>
        {isIdCards &&
          !element?.cardElementConfiguration?.background_color &&
          !element?.cardElementConfiguration?.asset_image?.id && (
            <>
              <CardDesignerCardElementPlaceholder />
              <Badge badgeSize="xs" badgeStyle="info">
                {helpPlaceholder ? helpPlaceholder : 'BACKGROUND'}
              </Badge>
            </>
          )}
      </div>
    </div>
  );
};

CardDesignerCardElementBackground.propTypes = propTypes;

export default CardDesignerCardElementBackground;
